import AppointmentSeries from '../dto/offering/AppointmentSeries';
import Error from '../model/Error';
import axios from 'axios';

export default class AppointmentSeriesRepository {
    static findAll(offering) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/offering/${offering.id}/appointment-series`)
                .then(response => resolve(response.data.data.map(data => AppointmentSeries.fromData(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static add(appointmentSeries, offering) {
        return new Promise((resolve, reject) => {
            axios
                .post(`/club/offering/${offering.id}/appointment-series`, {
                    start: appointmentSeries.start,
                    end: appointmentSeries.end,
                    interval: appointmentSeries.interval,
                    intervalEnd: appointmentSeries.intervalEnd
                })
                .then(response => resolve(response.headers['location'].split('/').pop()))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static update(appointmentSeries) {
        return new Promise((resolve, reject) => {
            axios
                .put(`/club/appointment-series/${appointmentSeries.id}`, {
                    start: appointmentSeries.start,
                    end: appointmentSeries.end,
                    interval: appointmentSeries.interval,
                    intervalEnd: appointmentSeries.intervalEnd
                })
                .then(response => resolve(response.data.data))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static delete(appointmentSeries) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`/club/appointment-series/${appointmentSeries.id}`)
                .then(response => resolve(response.data.data))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }
}
